import { baseApi } from '../baseApi';

export interface Question {
  id: string;
  text: string;
  image?: string | null;
  type: 'mcq' | 'multiple' | 'input';
  options?: string[];
  correctAnswer: any;
  marks: number;
  explanation?: string | null;
  difficulty?: 'easy' | 'medium' | 'hard';
  testId: string;
  subjectId: string;
  chapterId: string;
  createdAt: string;
  subject?: { name: string };
  chapter?: { name: string };
}

export interface Test {
  id: string;
  title: string;
  description?: string | null;
  timeLimit: number;
  totalMarks: number;
  passingMarks: number;
  isActive: boolean;
  chapterId: string;
  subjectId: string;
  academicYearId: string;
  classId: string;
  createdAt: string;
  chapter?: { name: string };
  subject?: { name: string };
  questions?: { id: string }[];
}

export const testApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTests: builder.query<{ success: boolean; data: Test[]; total: number }, any>({
      query: (params) => ({
        url: '/api/tests',
        params,
      }),
      providesTags: ['Test'],
    }),
    createTest: builder.mutation<{ success: boolean; data: Test }, Partial<Test>>({
      query: (body) => ({
        url: '/api/tests',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Test', 'Dashboard'],
    }),
    updateTest: builder.mutation<{ success: boolean; data: Test }, { id: string; body: Partial<Test> }>({
      query: ({ id, body }) => ({
        url: `/api/tests/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Test', 'Dashboard'],
    }),
    deleteTest: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/tests/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Test', 'Dashboard'],
    }),
    // Questions
    getTestQuestions: builder.query<{ success: boolean; data: Question[] }, string>({
      query: (testId) => `/api/tests/${testId}/questions`,
      providesTags: ['Question'],
    }),
    addQuestion: builder.mutation<{ success: boolean; data: Question }, { testId: string; body: Partial<Question> }>({
      query: ({ testId, body }) => ({
        url: `/api/tests/${testId}/questions`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Question', 'Test'],
    }),
    updateQuestion: builder.mutation<{ success: boolean; data: Question }, { id: string; body: Partial<Question> }>({
      query: ({ id, body }) => ({
        url: `/api/tests/questions/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Question'],
    }),
    deleteQuestion: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/tests/questions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Question', 'Test'],
    }),
  }),
});

export const {
  useGetTestsQuery,
  useCreateTestMutation,
  useUpdateTestMutation,
  useDeleteTestMutation,
  useGetTestQuestionsQuery,
  useAddQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
} = testApi;
